import { Component,ViewChild } from '@angular/core';
import { NavController,AlertController,ToastController,ModalController, NavParams, ViewController,Searchbar } from 'ionic-angular';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
import { Params } from '../../params';
import * as firebase from 'firebase/app';
import {GlobalProvider} from "../../../providers/global/global";
import * as moment from 'moment';

@Component({
  selector: 'page-restrictions',
  templateUrl: 'restrictions.html'
})
export class RestrictionsPage{
  restrictions = [];
  history = [];
  items;
  types = { 1: "Ingrediente",2 : "Grupo de Ingredientes",3 : "Receta"};
  ingredients;
  groupingredients;
  rest_cat;
  customers;
  filter:string;
  user;
  recipes;
  tabs = "restrictions";
  constructor(
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public params: NavParams,
    public global: GlobalProvider
  ){
    this.user = this.params.get("user");
    // this.getHistory();
    console.log(Params.md5(this.user.email));

    firebase.database().ref('/customers/'+Params.md5(this.user.email)+'/restrictions').once('value')
      .then((snap)=>{
        if(snap.exists()){
          const val = snap.val();
          this.restrictions = Object.keys(val).map(key =>{ return { key:key, ...val[key]}});

        }
      });

    firebase.database().ref('/customers/'+Params.md5(this.user.email)+'/history/restrictions').once('value')
    .then((snap)=>{
      if(snap.exists()){
        const val = snap.val();
        this.history = Object.keys(val).map(key =>{ return { key:key, ...val[key]}});

      }
    });

    this.ingredients = this.global.ingredients;
    this.groupingredients = this.global.gingredients;
    this.recipes = this.global.recipes;

    firebase.database().ref('/restrictions/categories').once('value').then((snapshot)=>{
      this.rest_cat = (<any>Object).values(snapshot.val());
    });
  }

  add(){
    let modal = this.modalCtrl.create(RestrictionPage, {user:Params.md5(this.user.email),recipes:this.recipes,ingredients : this.ingredients,groups:this.groupingredients,rest_cat : this.rest_cat});
    modal.present();
    modal.onDidDismiss((d)=>{
      console.log(d.data);
      this.restrictions.push(d.data);
      this.history.push(d.history);
    })
  }

  getHistory() {
    if(!this.user.history) {
      return;
    }
    const historyRest = Object.keys(this.user.history.restrictions);
    for(let i of historyRest) {
      this.history.unshift(this.user.history.restrictions[i]);
    };
    console.log('history', this.history);
  }

  remove(i){
    let confirm = this.alertCtrl.create({
      title: 'Eliminar',
      message: '¿Está seguro de eliminar la restriccion de '+i.ingredient_name+'?',
      buttons: [
        {
          text: 'Cancelar',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'Si, deseo eliminarlo',
          handler: () => {
            console.log(i);
            const key2 = firebase.database().ref(`/customers/${Params.md5(this.user.email)}/history`).child('restrictions').push().key;
            let hist = {...i};
            hist['datetime'] = firebase.database.ServerValue.TIMESTAMP;
            hist['key'] = key2;
            hist['status'] = 'removed';
            hist['owner'] = Params.USER_DATA.email;

            firebase.database().ref('/customers/'+Params.md5(this.user.email)+'/restrictions/'+i.key)
              .remove().then((x)=>{
                console.log('then x', x);
                firebase.database().ref(`/customers/${Params.md5(this.user.email)}/history/restrictions/${key2}`).update(hist);

                this.history.push(hist);

                this.restrictions = this.restrictions.filter((r)=>r.key!=i.key);
                console.log("deleted",i.key);
            }).catch((err) => {
              console.log('catch err', err);
            }); 
          }
        }
      ]
    });
    confirm.present();
  }

  formatTime(date) {
    return moment(date).format('DD-MM-YYYY H:mm:ss');
  }

  statusText(data) {
    let text = 'n/a';
    if(data == 'added') text = 'Creada';
    if(data == 'removed') text = 'Eliminada';
    return text;
  }
}


@Component({
  template: `
<ion-header>
  <ion-toolbar>
    <ion-title>
      Creando restricción
    </ion-title>
    <ion-buttons end>
      <button ion-button [disabled]="!addForm.valid" (click)="save()">
        Guardar
      </button>
  </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list>
  <form [formGroup]="addForm" (ngSubmit)="onSubmit(addForm)">
    <ion-item>
        <ion-label>Motivo</ion-label>
        <ion-select formControlName="reason" name="reason" (ionChange)="changeReason()">
          <ion-option *ngFor="let i of cats">{{i}}</ion-option>
        </ion-select>
    </ion-item>
    <div *ngIf="reason">
      <ion-item>
        <ion-label>Tipo</ion-label>
        <ion-select formControlName="type" name="type" (ionChange)="changeType()">
          <ion-option [value]="1">Ingrediente</ion-option>
          <ion-option [value]="2">Grupo de Ingredientes</ion-option>
          <ion-option [value]="3">Receta</ion-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label>Restricción</ion-label>
        <ion-input [value]="restriction" [disabled]="true"></ion-input>
      </ion-item>
      <ion-item >
        <ion-searchbar #searchbar (ionInput)="getItems($event)" placeholder="Buscar"></ion-searchbar>
        <ion-list>
          <ion-item *ngFor="let i of items" (click)="selectItem(i)">
            {{ i.name }}
          </ion-item>
        </ion-list>
      </ion-item>
    </div>
  </form>
  </ion-list>
</ion-content>
`
})
export class RestrictionPage{
  @ViewChild('searchbar') searchbar: Searchbar;
  addForm: FormGroup;
  user;
  ingredients = [];
  groups = [];
  cats = [];
  items = [];
  reason = false;
  recipes = [];
  restriction : string = "";
  constructor(
    private builder: FormBuilder,
    private params : NavParams,
    public viewCtrl: ViewController,
  ){
    this.user = this.params.get("user");
    this.cats = this.params.get("rest_cat");

    this.addForm = builder.group({
      'reason': ['', Validators.required],
      'value': [''],
      'type': [1, Validators.required]
    });
    this.initializeItems();
  }


  initializeItems(){
    if(this.addForm.value.type==1) this.items = (<any>Object).values(this.params.get("ingredients"));
    if(this.addForm.value.type==2) this.items = (<any>Object).values(this.params.get("groups"));
    if(this.addForm.value.type==3) this.items = (<any>Object).values(this.params.get("recipes"));
  }

  changeReason(){
    this.reason = true;
  }

  changeType(){
    this.searchbar.clearInput(null);
    this.initializeItems();
    this.addForm.value.value = "";
    this.restriction = "";
  }

  getItems(ev: any) {
    this.initializeItems();
    if(ev){
      let val = ev.target.value;
      if (val && val.trim() != '') {
        this.items = this.items.filter((item) => {
          return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1;
        })
      }
    }

  }

  selectItem(d){
    this.addForm.value.value = d.key;
    this.restriction = d.name;
  }

  save(){
    if(this.addForm.value.value!=''){
      let save = {
        "datetime" : firebase.database.ServerValue.TIMESTAMP,
        "reason" : this.addForm.value.reason,
        "type" : this.addForm.value.type,
        "value" : this.addForm.value.value,
        "value_name" : this.restriction,
        "reason_value" : this.cats.indexOf(this.addForm.value.reason)
      };
      const key = firebase.database().ref('/customers/'+this.user).child('restrictions').push().key;
      save['key'] = key;
      save['owner'] = Params.USER_DATA.email;
      console.log(key);
      
      const key2 = firebase.database().ref(`/customers/${this.user}/history`).child('restrictions').push().key;
      let hist = {...save};
      hist['key'] = key2;
      hist['status'] = 'added';

      
      firebase.database().ref('/customers/'+this.user+'/restrictions/'+key).update(save)
      .then(()=>{
          firebase.database().ref(`/customers/${this.user}/history/restrictions/${key2}`).update(hist);

          this.viewCtrl.dismiss({data:save, history: hist});
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/customers/restrictions/restrictions.ts